import { Loader2, Plus } from 'lucide-react'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@teach/ui'
import type { Lang } from '@/types/lang'
import { LANG_INFO } from '@/features/editor/lib/courseLanguages'
import { LanguageFlag } from '@/components/layout/sidebar/LanguageFlag'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  langs: Lang[]
  disabled: boolean
  pending: boolean
  onAdd: (lang: Lang) => void
}

/** Добавление языка курса: выбор из доступных. */
export const AddLanguageMenu = ({ langs, disabled, pending, onAdd }: Props) => {
  const m = useMessages(messages)
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled}>
          {pending ? (
            <Loader2 aria-hidden className="mr-2 size-3.5 animate-spin" />
          ) : (
            <Plus aria-hidden className="mr-2 size-3.5" />
          )}
          {m.addLanguage}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {langs.map((lang) => (
          <DropdownMenuItem key={lang} className="gap-2" onSelect={() => onAdd(lang)}>
            <LanguageFlag lang={lang} className="size-5" />
            {LANG_INFO[lang].name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
